


import watchNewContaReceber from './saga/new';
import watchNewFilterContaReceber from './saga/newFilter';
import watchFindContaReceber from './saga/find';
import watchFindPagamentos from './saga/findPagametos';
import watchCreateContaReceber from './saga/create';
import watchNewFilterNextPageContaReceber from './saga/newFilterNextPage';
import watchDeleteContaReceber from './saga/delete';
import watchEstornarPagamentoContaReceber from './saga/estornarPagamento';
import watchDeleteMultipleContaReceber from './saga/deleteMultiple';
import watchEstornarMultiplePagamentoContaReceber from './saga/estornarMultiplePagamento';

export const contaReceberSaga = [
    watchNewContaReceber(),
    watchNewFilterContaReceber(),
    watchFindContaReceber(),
    watchFindPagamentos(),
    watchCreateContaReceber(),
    watchNewFilterNextPageContaReceber(),
    watchDeleteContaReceber(),
    watchDeleteMultipleContaReceber(),
    watchEstornarPagamentoContaReceber(),
    watchEstornarMultiplePagamentoContaReceber(),
]

export * from './actionTypes';
export * from './reducer';
export * from './service';
export * from './entity';
